import type { ComponentProps } from 'react';

import { cn } from '@/shared/lib/cn';

export const inputBaseClass =
  'flex w-full min-w-0 rounded-md border border-input bg-background text-sm shadow-xs transition-[border-color,box-shadow] outline-none placeholder:text-subtle-foreground hover:border-border-strong focus-visible:border-brand/60 focus-visible:ring-3 focus-visible:ring-ring/25 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:focus-visible:ring-destructive/20 dark:bg-input/15';

export function Input({ className, type = 'text', ...props }: ComponentProps<'input'>) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        inputBaseClass,
        'h-9 px-3 py-1 file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium',
        className,
      )}
      {...props}
    />
  );
}
